import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  createItem: [],
  loading: false,
  error: null,
};

const createItemSlice = createSlice({
  name: "createItem",
  initialState,
  reducers: {
    fetchCreateItemRequest: (state) => {
      state.loading = true;
      state.error = null;
    },

    fetchCreateItemSuccess: (state, action) => {
      state.loading = false;
      state.createItem = action.payload;
    },

    fetchCreateItemFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export const {
  fetchCreateItemRequest,
  fetchCreateItemSuccess,
  fetchCreateItemFailure,
} = createItemSlice.actions;

export default createItemSlice.reducer;